import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AppService {
	constructor() {}

	offlineErrorEmmiter = new EventEmitter<unknown>();

	CloseModalEmmiter = new EventEmitter<unknown>();
	ShowModalEmmiter = new EventEmitter<unknown>();

	setOfflineError(time: number) {
		this.offlineErrorEmmiter.emit({ show: true, time });
	}

	resetOfflineError() {
		this.offlineErrorEmmiter.emit({ show: false });
	}

	public showModal(
		headerLabels: unknown,
		buttons: unknown,
		body: unknown = null,
		onlyBodyModal: unknown = null,
		fullScreen: unknown = null,
	) {
		this.ShowModalEmmiter.emit({
			headerLabels,
			buttons,
			body,
			onlyBodyModal,
			fullScreen,
		});
	}

	public closeModal() {
		this.CloseModalEmmiter.emit();
	}
}
